import { CHANGE_NAVBAR } from "../constants";

export const changeNavbar = (navbarRoute: string) => {
  return {
    type: CHANGE_NAVBAR,
    navbarRoute,
  }; 
};
